var _path, _path2, _circle, _path3, _rect, _circle2, _path4, _path5;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoAccessIcon = function SvgNoAccessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 95,
    viewBox: "0 0 89 95",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 3C27.835 3 20 10.835 20 20.5V33H55V20.5C55 10.835 47.165 3 37.5 3Z",
    fill: "#DFEDF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 95V31.6667H16.791V20.5556C16.791 14.8148 18.7966 9.9537 22.8078 5.97222C26.819 1.99074 31.7164 0 37.5 0C43.2836 0 48.181 1.99074 52.1922 5.97222C56.2034 9.9537 58.209 14.8148 58.209 20.5556V31.6667H75V95H0ZM3.91791 91.1111H71.0821V35.5556H3.91791V91.1111ZM20.709 31.6667H54.291V20.5556C54.291 15.9259 52.6586 11.9907 49.3937 8.75C46.1287 5.50926 42.1642 3.88889 37.5 3.88889C32.8358 3.88889 28.8713 5.50926 25.6063 8.75C22.3414 11.9907 20.709 15.9259 20.709 20.5556V31.6667Z",
    fill: "#0C2945"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5005,
    cy: 38.4966,
    r: 11.02,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 24C66.496 24 60 30.496 60 38.5C60 46.504 66.496 53 74.5 53C82.504 53 89 46.504 89 38.5C89 30.496 82.504 24 74.5 24ZM75.95 45.75H73.05V42.85H75.95V45.75ZM75.95 39.95H73.05V31.25H75.95V39.95Z",
    fill: "#00AEEF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 62,
    width: 7,
    height: 13,
    fill: "#0C2945"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 58.5,
    r: 6.5,
    fill: "#0C2945"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 75L34 64V75H32Z",
    fill: "#0C2945"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75L41 64V75H43Z",
    fill: "#0C2945"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAccessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-access-icon.ad2cd4b7.svg";
export { ForwardRef as ReactComponent };